import React from 'react'
import { PropertyResponseItem, PropertyType } from 'components/search/models/property-search-response'
import { getMainProperty, isSectionedPropertyParent } from 'utils/cadastre-utils'
import { SectionedPropertyParentView } from './SectionedPropertyParentView'
import { SectionedPropertyChildView } from './SectionedPropertyChildView'
import { EmptySectionedPropertyChildView } from './EmptySectionedPropertyChildView'

type SectionedPropertyViewProps = {
    units: PropertyResponseItem[]
    type: PropertyType
}

export const SectionedPropertyView: React.FC<SectionedPropertyViewProps> = ({ units, type }) => {
    const mainProperty = getMainProperty(units) || units[0]
    const isParent = isSectionedPropertyParent(mainProperty.cadastreNumber)

    if (isParent) return <SectionedPropertyParentView units={units} type={type} />

    return mainProperty.housingUnits.length === 0 ? (
        <EmptySectionedPropertyChildView cadastreNr={mainProperty.cadastreNumber} propertyType={type} />
    ) : (
        <SectionedPropertyChildView units={units} />
    )
}
